import LogoMark from "@/User/Assets/Svgs/LogoMark.svg";
import React from "react";
import Typography from "./Typography";
import { LazyLoadImage } from "react-lazy-load-image-component";

const CopyRight = () => {
    return (
        <div className="w-full flex flex-col items-center justify-center gap-4 my-10">
            <a href="https://privacymark.jp/" target="_blank" rel="noopener noreferrer">
                <LazyLoadImage src={LogoMark} width={40} height={40} alt="プライバシーマーク" />
            </a>
            <Typography variant="small" className="mt-0.5 leading-25.2px text-justify">
                © ZIGExN Co., Ltd. All Rights Reserved.
            </Typography>
        </div>
    );
};

export default CopyRight;
